import React from "react";

const PATHS = {
  view: <><path d="M2.8 12s3.3-5.5 9.2-5.5 9.2 5.5 9.2 5.5-3.3 5.5-9.2 5.5S2.8 12 2.8 12Z"/><circle cx="12" cy="12" r="2.5"/></>,
  download: <><path d="M12 3v11"/><path d="m7.5 10 4.5 4.5 4.5-4.5"/><path d="M5 20h14"/></>,
  delete: <><path d="M4 7h16"/><path d="m9 7 .7-2h4.6l.7 2"/><path d="m6.5 7 .8 13h9.4l.8-13"/><path d="M10 11v5M14 11v5"/></>,
  edit: <><path d="m4 20 4.2-1 10-10a2.1 2.1 0 0 0-3-3l-10 10L4 20Z"/><path d="m13.8 7.2 3 3"/></>,
  update: <><path d="M20 7v5h-5"/><path d="M4 17v-5h5"/><path d="M6.1 8.2A7 7 0 0 1 18.8 7L20 12"/><path d="M4 12l1.2 5A7 7 0 0 0 17.9 15.8"/></>,
};

export default function MediaActionIcon({ type, className = "" }) {
  return (
    <svg className={`mediaActionIcon${className ? ` ${className}` : ""}`} viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      {PATHS[type] || PATHS.view}
    </svg>
  );
}

export function MediaActionLoading() {
  return <span className="mediaActionLoading" aria-hidden="true" />;
}
